/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useEffect,
  useRef,
  FC,
  Children,
} from 'react';
import { css, jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { interactionContext } from './interactionContext';
import { unlockInteraction } from 'services/unlockInteraction';
import { Box } from 'theme-ui';
import EditMarker from 'components/UI/EditMarker';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { useSelector } from 'react-redux';
import EditCardWrapper from './EditCardWrapper';
// import Masonry from 'masonry-layout';
import Masonry from './Masonry';
import { grids } from './grids';

const { lPink, lGrey2 } = colors;

const ContentCards: FC = ({ children, ...props }) => {
  const context: any = useContext(interactionContext);
  let { grid, numColumns, uniformHeight } = context.props;
  const [init, setInit] = useState(false);
  const gridContainer = useRef<HTMLDivElement>(null);

  const updateCounter = useRef<number>(0);
  const masonryContainer = useRef<HTMLSpanElement>(null);
  const cardOrder = useRef<string>('');
  cardOrder.current = Children.map(children, (child: any, index) => {
    const { props } = child.props.children[1];

    const { id } = props;
    return id;
  }).join();

  console.log(cardOrder.current);

  const images: string[] = [];

  const imagesInCards = cards => {
    [...cards].forEach((card: React.ReactElement) => {
      if (card && card.props) {
        if (card.props.child === 1) {
          !images.includes(card.props.src) && images.push(card.props.src);
        }

        if (card.props.children && card.props.children.length) {
          imagesInCards(card.props.children);
        }
      }
    });
  };

  imagesInCards(children);

  if (['masonry', 'uniformHeight'].includes(grid)) {
    return (
      <Masonry
        key={`masonry_${Children.count(children)}_${numColumns}_${grid}_${
          cardOrder.current
        }`}
        maxColumns={numColumns}
        maxGridWidth={1100}
        minCellWidth={320}
        images={images}
        uniformHeight={grid === 'uniformHeight'}
      >
        {Children.map(children, (child: any, index: number) => {
          return (
            <Box
              key={child.props.id}
              // className="grid-item"
              sx={{
                position: 'relative',
                padding: '20px',
                ...(grid === 'uniformHeight' && {
                  height: '100%',
                  '.card': {
                    height: '100%',
                    // outline: '2px solid red',
                  },

                  //
                }),
              }}
            >
              {window.dev && window.dev() && (
                <EditCardWrapper id={child.props.id} />
              )}
              {React.cloneElement(child, {
                parentId: (props as any).id,
                className: `card-${index}`,
                ...(grid === 'bannerColumns' &&
                  {
                    //
                  }),
              })}
            </Box>
          );
        })}
      </Masonry>
    );
  }

  return (
    <Box
      useRef={gridContainer}
      sx={{
        // outline: '2px solid lime',
        ...css(grids(grid, { numColumns, children })),
        // ...grids(grid, { numColumns, children }),
        width: '100%',
        height: '100%',
      }}
    >
      {Children
        // .filter((child: any, index: number) => {
        //   return (
        //     ['masonry', 'uniformHeight'].includes(grid) || index < gridCellCount
        //   );
        // })
        .map(children, (child: any, index: number) => {
          const className = `grid-cell-${index}`;

          // const msGridColumn = ((numColumns + index) % numColumns) + 1;
          // const msGridRow = Math.trunc(index / numColumns) + 1;

          return (
            <Box
              key={className}
              className={className}
              sx={{
                position: 'relative',
                padding: '20px',

                ...(['uniformHeight'].includes(grid) && {
                  '> div': {
                    height: '100%',
                  },

                  // msGridColumn,
                  // msGridRow,
                }),

                ...(['bannerColumns'].includes(grid) && {
                  // '> div:not(:first-child)': {
                  '> div': {
                    height: '100%',
                  },
                }),
              }}
            >
              {window.dev && window.dev() && (
                <EditCardWrapper id={child.props.id} />
              )}
              {React.cloneElement(child, {
                parentId: (props as any).id,
                className: `card-${index}`,
                ...(grid === 'bannerColumns' &&
                  index === 0 && {
                    checkBannerColumnsForDefaultImage: true,
                  }),
              })}
            </Box>
          );
        })}
    </Box>
  );
};

export default ContentCards;
